import React from 'react';

export const component = props => (
  <svg
    style={{ width: '120%' }}
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 99.4 75.8"
  >
    <path
      fill={props.color}
      d="M6.7 53.2l-.2-2.4V4A3.8 3.8 0 0 1 9.2.2a5.3 5.3 0 0 1 1.4-.2h66.1a3.8 3.8 0 0 1 4 4v26.7l3.4 1c8.3 3 13.4 8.9 15 17.5a22.6 22.6 0 0 1-42.4 14.4.9.9 0 0 0-1-.5H2.9a2.5 2.5 0 0 1-1-.2 1.1 1.1 0 0 1-.5-1L0 54.8c-.2-1 .3-1.5 1.3-1.5h5.4zm47.3 0a22.8 22.8 0 0 1 24.5-22.7V4c0-1.3-.5-1.9-1.8-1.9H10.6c-1.3 0-1.9.6-1.9 2v47.1c0 1.4.6 2 2 2H54zm43.2 0a20.5 20.5 0 1 0-20.5 20.4A20.4 20.4 0 0 0 97.2 53zM54 55.4H2.5a1.8 1.8 0 0 0 0 .4l.7 4.4c.1.5.3.6.7.6h51.4z"
    />
    <path
      fill={props.color}
      d="M43.6 7.5a1.7 1.7 0 0 1 0-3.3 1.7 1.7 0 0 1 1.7 1.6 1.7 1.7 0 0 1-1.7 1.7zm0-1.1a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.5.5.5 0 0 0-.5.5.5.5 0 0 0 .5.6zM89 52.4l-3.5-3.7-3.2-3.4a1.1 1.1 0 1 1 1.6-1.6l7.4 7.8a1.1 1.1 0 0 1 0 1.8L83.9 61a1.1 1.1 0 0 1-1.7.1 1.1 1.1 0 0 1 0-1.6l6.3-6.6zM63.5 52.4l.4.5 6.3 6.6a1.8 1.8 0 0 1 .4.9 1 1 0 0 1-.6 1 1 1 0 0 1-1.1 0 2.7 2.7 0 0 1-.4-.3l-7.2-7.7a1.2 1.2 0 0 1 0-1.9l7.2-7.7a1.3 1.3 0 0 1 1.1-.5 1.1 1.1 0 0 1 .8 1.8l-.5.6-6.1 6.4zM80.4 44.6a3.9 3.9 0 0 1-.1.4l-6 15.6a1.1 1.1 0 1 1-2.1-.8l6-15.6a1.1 1.1 0 0 1 2.2.4zM43.6 59.3h-6.9a1.1 1.1 0 1 1 0-2.3h13.8a1.1 1.1 0 0 1 1.1 1.6 1.2 1.2 0 0 1-1.1.7z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/softwaresSVG.jsx